import {EquipmentDataDropDownInput} from "../../index";
import {getPrefixAlphabetsAndSuffixDigitsFromSite} from "../../../util/Utils";
import {AppConfig, AppConfigMapKey} from "../../config/AppConfig";
import {CABLING_STATUS_ENUM, POSITION_STATUS_ENUM, SHIPMENT_STATUS_MAPPING} from "../LmdpConstants";
import {StatusIndicatorProps} from "@amzn/awsui-components-react-v3";

export interface Value {
    valueType: string,
    valueString: string
}

export function parseValue(value: Value): any {
    if(value.valueType === "string") {
        return value.valueString
    } else if(value.valueType === "NUMBER") {
        return Number(value.valueString)
    }
}

export function getSortedEquipmentDataDropDownInput(equipmentList: EquipmentDataDropDownInput[]) : EquipmentDataDropDownInput[] {
    const sortAlphaNum = (a: EquipmentDataDropDownInput, b : EquipmentDataDropDownInput) => a.label.localeCompare(b.label, 'en', { numeric: true });

    return equipmentList.sort(sortAlphaNum);
}

export function getBoostExternalLink(assetId: string): string {
    const boostLink : string =  'https://app.boost.aws.a2z.com/platform/work-requests?searchInput=';
    return boostLink + assetId;

}
export function getRatsExternalLink(site: string, cluster: string, az: string) : string {
    let linkAZ: string = normalizeSiteWithLeftPadding(az);
    let linkSite: string = normalizeSiteWithLeftPadding(site);
    return `https://rdpm.amazon.com/rack_allocation_tool?cluster=${cluster}&az=${linkAZ}AZ&site=${linkSite}&button=#racks_in_works`
}

export function getRatsV2ExternalLink(demandid: string) : string {
    const argoPortalUrl = AppConfig.getConfigValue(AppConfigMapKey.ARGO_PORTAL_URL);
    return `${argoPortalUrl}/dc-rack-provisioning/demand/${demandid}`
}

export function getTownsendLink(ipn: string) : string {
    const townsendLink : string = `https://aws.argo.ocean-wave.aws.a2z.com/townsend/part/detail/`
    return townsendLink + ipn
}

/**
 * Takes in the site and left pad it with 3 zeros
 * Assuming site to follow the regex /^([a-zA-Z]+)(\d+)$/ otherwise this method will return original site
 *
 * @param site
 * @returns normalizedString
 */
export function normalizeSiteWithLeftPadding(site: string) {
    const [sitePrefix, siteSuffix] = getPrefixAlphabetsAndSuffixDigitsFromSite(site);

    if (siteSuffix != null) {
        return sitePrefix + siteSuffix.padStart(3, '0');
    }

    return site;
}

export function determineStatusType(state: string): StatusIndicatorProps.Type | null {
    if(state === CABLING_STATUS_ENUM.CABLED || state === POSITION_STATUS_ENUM.GREEN || 
        state === SHIPMENT_STATUS_MAPPING['delivered at dc']) {
        return 'success'
    } else if(state === CABLING_STATUS_ENUM.IN_PROGRESS || state === POSITION_STATUS_ENUM.YELLOW || 
        state === SHIPMENT_STATUS_MAPPING['ready to ship'] || state === SHIPMENT_STATUS_MAPPING['shipped']) {
        return 'in-progress';
    } else if(state === SHIPMENT_STATUS_MAPPING['not ready to ship']) {
        return 'pending';
    } else if(state === SHIPMENT_STATUS_MAPPING['on hold']) {
        return 'stopped';
    }
    else if(state === CABLING_STATUS_ENUM.PENDING || state === CABLING_STATUS_ENUM.DECABLING || state === CABLING_STATUS_ENUM.NOT_CABLED ||
        state === POSITION_STATUS_ENUM.RED || state === SHIPMENT_STATUS_MAPPING['-']) {
        return 'error';
    }
    return null;
}